import { render } from "./ViewPayrollConfig.vue?vue&type=template&id=2289229c&scoped=true"
import script from "./ViewPayrollConfig.vue?vue&type=script&lang=js"
export * from "./ViewPayrollConfig.vue?vue&type=script&lang=js"

import "./ViewPayrollConfig.vue?vue&type=style&index=0&id=2289229c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2289229c"]])

export default __exports__